<template>
  <a-row>
    <a-col :span="21">
      <div class="increaseCase">
        <a-spin tip="Loading..." :spinning="spinning">
          <div class="spin-content" id="print">
            <div style="margin:18px 0" class="no-print">
              <Breadcrumb :breadcrumb="breadcrumb" />
            </div>
            <div id="CaseBaseForm" style="padding:20px 29px 0;background: #fff;border-radius:2px;">
              <cardTitle title="帮扶对象信息" />
              <div style="margin-top:18px;">
                <CaseBaseForm
                  ref="caseBaseForm"
                  :initData="{ ...initData.init_value.process_base_table_message, assitLog }"
                  :checkDisplay="checkDisplay"
                  :checkDisabled="checkDisabled"
                  :minzuList="minzuList"
                  :pageType="pageType"
                  @xingmingOnchange="xingmingOnchange"
                />
                <FamilyForm
                  ref="familyForm"
                  :initData="{ ...initData.init_value.process_base_table_message, projectRelate }"
                  :checkDisplay="checkDisplay"
                  :checkDisabled="checkDisabled"
                  :pageType="pageType"
                />
              </div>
            </div>
            <div
              id="CaseApplyForm"
              style="padding:20px 29px;background: #fff;border-radius:2px;margin-top:11px;"
            >
              <cardTitle title="申请信息" />
              <div style="margin-top:18px;">
                <CaseApplyForm
                  ref="caseApplyForm"
                  v-model="fund"
                  :initData="{
                    ...initData.init_value.process_base_table_message,
                    process_base_title: initData.init_value.process_base_title || ''
                  }"
                  :checkDisplay="checkDisplay"
                  :checkDisabled="checkDisabled"
                  :pageType="pageType"
                />
              </div>
            </div>
            <div
              id="ExamineForm"
              style="padding:20px 29px;background: #fff;border-radius:2px;margin-top:11px;"
            >
              <cardTitle title="审核信息" />
              <div style="margin-top:18px;">
                <ExamineForm
                  ref="examineForm"
                  v-model="fund"
                  :initData="{ ...initData.init_value.process_base_table_message }"
                  :checkDisplay="checkDisplay"
                  :checkDisabled="checkDisabled"
                  :pageType="pageType"
                />
              </div>
            </div>
            <div
              id="ReviewForm"
              style="padding:20px 29px;background: #fff;border-radius:2px;;margin-top:11px;"
            >
              <cardTitle title="评议信息" />
              <div style="margin-top:18px;">
                <ReviewForm
                  ref="reviewForm"
                  :initData="{ ...initData.init_value.process_base_table_message }"
                  :checkDisplay="checkDisplay"
                  :checkDisabled="checkDisabled"
                  @shifouqushenpiChange="shifouqushenpiChange"
                  :pageType="pageType"
                />
              </div>
            </div>
            <div
              id="GrantForm"
              v-if="
                this.pageType === 'approvalFund' || processData.process_base_status === 'Finished'
              "
              style="padding:20px 29px;background: #fff;border-radius:2px;;margin-top:11px;"
            >
              <cardTitle title="发放信息" />
              <div style="margin-top:18px;">
                <GrantForm
                  ref="grantForm"
                  :initData="{ ...initData.init_value.process_base_table_message }"
                  :checkDisplay="checkDisplay"
                  :checkDisabled="checkDisabled"
                />
              </div>
            </div>
            <div
              id="Approval"
              style="padding:20px 29px;background: #fff;border-radius:2px;margin-top:11px;"
              v-if="checkDisplay('approval')"
            >
              <cardTitle title="审批" />
              <div style="margin-top:18px;">
                <Approval
                  :approvalInfo="{ approvalResult: '', approvalOpinion: '' }"
                  ref="approval"
                />
                <!--<leader-select :approvalPeople="initData.process_config || []" ref="leaderList"/>-->
              </div>
            </div>
            <div
              id="leader-select"
              style=""
              v-if="checkDisplay('approvalLeader')"
            >
              <cardTitle title="审批人" style="display:none" />
              <div style="margin-top:18px;">
                <leader-select
                  :approvalPeople="initData.process_config || []"
                  ref="leaderList"
                  :fund="fund"
                  :pageType="pageType"
                  who="个案帮扶"
                />
              </div>
            </div>
            <!-- :shifouqushenpi="shifouqushenpiVal" -->
            <!-- <div
              id="Noticeread"
              style="padding:20px 29px;background: #fff;border-radius:2px;margin-top:11px;"
            >
              <cardTitle title="通知阅读" />
              <div style="margin-top:18px;">
                <Noticeread
                  :approvalPeople="initData.notice_reader || []"
                  ref="noticeRead"
                  :pageType="pageType"
                />
              </div>
            </div>-->
            <div
              id="ApprovalList"
              style="padding:20px 29px;background: #fff;border-radius:2px;margin-top:11px;"
              v-if="checkDisplay('approvalList')"
            >
              <cardTitle title="业务流转记录" />
              <div style="margin-top:18px;" class="table">
                <ApprovalList :dataSource="initData.process_business_message || []" />
              </div>
            </div>
            <div
              class="formButton"
              style="margin-top:20px;text-align: right"
              v-if="checkDisplay('button')"
            >
              <a-button type="primary" @click="saveDraft" v-if="checkDisplay('save')">保存</a-button>
              <a-button type="primary" @click="zancun" v-if="checkDisplay('zancun')">暂存</a-button>
              <a-button
                type="primary"
                :style="{ marginLeft: '8px' }"
                @click="onSubmit"
                v-if="checkDisplay('submit')"
              >提交</a-button>
              <a-button
                type="primary"
                :style="{ marginLeft: '8px' }"
                @click="() => onConfirm(true)"
                v-if="checkDisplay('confirm')"
              >发放</a-button>
              <!-- <a-button
                type="primary"
                :style="{ marginLeft: '8px' }"
                @click="() => onConfirm()"
                v-if="checkDisplay('confirm')"
              >
                不同意
              </a-button>-->
              <a-button
                :style="{ marginLeft: '8px' }"
                @click="goToHistory"
                v-if="checkDisplay('cancel')"
              >取消</a-button>
            </div>
          </div>
          <div class="dayin-view" v-if="pageType === 'view'">
            <a-button type="primary" @click="dayin">打印</a-button>
          </div>
        </a-spin>
      </div>
    </a-col>
    <a-col :span="3" style="position: relative">
      <div style="position: absolute;width: 100%;top: 57px;left: 10px">
        <a-anchor :targetOffset="60" :offsetTop="60">
          <a-anchor-link href="#CaseBaseForm" title="帮扶对象信息" />
          <a-anchor-link href="#CaseApplyForm" title="申请信息" />
          <a-anchor-link href="#ExamineForm" title="审核信息" />
          <a-anchor-link href="#ReviewForm" title="评议信息" />
          <a-anchor-link
            v-if="
              this.pageType === 'approvalFund' || processData.process_base_status === 'Finished'
            "
            href="#GrantForm"
            title="发放信息"
          />
          <!--          <a-anchor-link href="#leader-select" title="审批人" />-->
          <!--          <a-anchor-link href="#Noticeread" title="通知阅读" />-->
          <a-anchor-link v-if="checkDisplay('approvalList')" href="#ApprovalList" title="业务流转记录" />
          <a-anchor-link v-if="checkDisplay('approval')" href="#Approval" title="审批" />
        </a-anchor>
      </div>
    </a-col>
  </a-row>
</template>

<script>
import cardTitle from '../../components/cardTitle'
import Breadcrumb from '@/components/breadcrumb'
import CaseBaseForm from '../../components/caseBaseForm'
import FamilyForm from '../../components/familyForm'
import CaseApplyForm from '../../components/caseApplyForm'
import leaderSelect from '@/components/leaderSelect'
import Approval from '@/components/approval'
import ApprovalList from '../../components/approval'
import ReviewForm from '../../components/reviewForm'
import ExamineForm from '../../components/examineForm'
import GrantForm from '../../components/grantForm'
import { mapActions } from 'vuex'
import { service } from './service'
import Noticeread from '@/components/noticeReader'
import request from '@/utils/request'
import moment from 'moment'
// eslint-disable-next-line no-unused-vars
import print from 'print-js'

export default {
  name: 'Index',
  components: {
    cardTitle,
    Breadcrumb,
    CaseBaseForm,
    FamilyForm,
    CaseApplyForm,
    leaderSelect,
    Approval,
    ApprovalList,
    ReviewForm,
    Noticeread,
    GrantForm,
    ExamineForm
  },
  data() {
    return {
      spinning: true,
      assitPeopleInfoFlag: false, // 是否已存在帮扶人员信息
      assitPeopleInfo: {}, // 帮扶人员具体信息
      pageType: 'launch', // 拟稿
      projectRelate: [], // 项目关联
      assitLog: [], // 帮扶日志
      initData: {
        init_value: {},
        process_business_message: {
          reviewForm: {}
        }
      }, // 表单默认数据
      processConfigType: 'individualCase', // 流程类型
      processData: {}, // 页面带过来的流程关键数据
      fund: '', // 帮扶资金
      breadcrumb: [
        {
          // 面包屑
          title: '综合帮扶',
          path: ''
        },
        {
          title: '个案帮扶',
          path: '/assit/compositeAssit/caseAssit'
        },
        {
          title: '个案帮扶申请',
          path: ''
        }
      ],

      minzuList: [],
      shifouqushenpiVal: null
    }
  },
  created() {
    // const userInfo = this.$store.getters.userInfo ? this.$store.getters.userInfo.user : {}
    // const permission = userInfo.user_permissions || []
    // const isShow = permission.filter(value => value === 'caseAssit')
    // if (!isShow || isShow.length <= 0) { // 无权限时
    //   if (this.$route.query && this.$route.query.pageType && this.$route.query.pageType === 'view') { // 判断页面跳转带过来的页面类型的值
    //     this.pageType = 'view'// 可以查看
    //     this.processData = this.$route.query.processData ? JSON.parse(this.$route.query.processData) : {}
    //   } else if (this.$route.query && this.$route.query.pageType && this.$route.query.pageType === 'approval') {
    //     this.pageType = 'approval'// 可以审批
    //     this.processData = this.$route.query.processData ? JSON.parse(this.$route.query.processData) : {}
    //   } else if (this.$route.query && this.$route.query.pageType && this.$route.query.pageType === 'approvalFund') { // 退回拟稿
    //     this.pageType = 'approvalFund'
    //     this.processData = this.$route.query.processData ? JSON.parse(this.$route.query.processData) : {}
    //   } else {
    //     this.$router.push({ path: '123' })
    //   }
    // } else { // 有权限时
    this.processData = this.$route.query.processData
      ? JSON.parse(this.$route.query.processData)
      : {}
    if (this.$route.query && this.$route.query.pageType) {
      // 判断页面跳转带过来的页面类型的值
      if (this.$route.query.pageType === 'approval') {
        // 审批
        this.pageType = 'approval'
      } else if (this.$route.query.pageType === 'draft') {
        // 草稿
        this.pageType = 'draft'
      } else if (this.$route.query.pageType === 'launch') {
        // 发起
        this.pageType = 'launch'
      } else if (this.$route.query.pageType === 'relaunch') {
        // 退回拟稿
        this.pageType = 'relaunch'
      } else if (this.$route.query.pageType === 'view') {
        // 只读
        this.pageType = 'view'
      } else if (this.$route.query.pageType === 'approvalFund') {
        // 发放
        this.pageType = 'approvalFund'
      }
    }
    // }
  },
  mounted() {
    if (this.pageType === 'launch') {
      // 拟稿
      this.InitProcess({ processConfigType: this.processConfigType }).then((result) => {
        // 查询页面初始数据
        // this.initData = this._.cloneDeep(result || {})
        // if (this.initData && this.initData.init_value && this.initData.init_value.process_base_table_message) {
        //   // console.log(this.initData.init_value.process_base_table_message)
        //   this.initData.init_value.process_base_table_message.need_help_person_number_id = JSON.parse(this.$route.query.idCard)
        // }
        service
          .needHelpPerson({ need_help_person_number_id: JSON.parse(this.$route.query.idCard) })
          .then((response) => {
            this.initData = this._.cloneDeep(result || {}) // 查询后台是否有该对象的信息，如果有就自动填充到页面并且不可更改
            // 对业务数据存储字段初始化赋值
            this.initData.process_business_message = {}
            this.initData.process_business_message.reviewForm = {}
            if (
              this.initData &&
              this.initData.init_value &&
              this.initData.init_value.process_base_table_message
            ) {
              // console.log(this.initData.init_value.process_base_table_message)
              this.initData.init_value.process_base_table_message.need_help_person_number_id = JSON.parse(
                this.$route.query.idCard
              )
            }
            this.getProject(JSON.parse(this.$route.query.idCard)) // 获取关联的项目
            if (response && response.length > 0) {
              // 判断能不能查帮扶人员的信息
              this.assitPeopleInfoFlag = true
              this.assitPeopleInfo = response[0]
              this.initData.init_value.process_base_table_message = Object.assign(
                {},
                this.initData.init_value.process_base_table_message,
                this.assitPeopleInfo
              )
            }
            this.spinning = false
          })
      })
    } else {
      const params = {
        process_base_work_number: this.processData.process_base_work_number
      }
      this.GetTaskBusinessData(params).then((result) => {
        // 查询已发起流程的表单数据
        const dd = this._.cloneDeep(result || {})
        if (this.processData.process_base_status === 'Finished') {
          dd.init_value.process_base_table_message = JSON.parse(
            dd.process_business_message.slice(-1)[0].process_base_table_message
          )
        }
        this.initData = dd
        this.fund = this.initData.init_value.process_base_table_message.individual_case_support_funds
        let idCard = ''
        if (
          this.initData &&
          this.initData.init_value &&
          this.initData.init_value.process_base_table_message
        ) {
          idCard = this.initData.init_value.process_base_table_message.need_help_person_number_id
          service.needHelpPerson({ need_help_person_number_id: idCard }).then((response) => {
            // 查询后台是否有该对象的信息
            this.getProject(idCard) // 获取关联的项目
            if (response && response.length > 0) {
              // 判断能不能查大帮扶人员的信息+
              this.assitPeopleInfoFlag = true
              this.assitPeopleInfo = response[0]
              // this.initData.init_value.process_base_table_message = Object.assign(
              //   {},
              //   this.initData.init_value.process_base_table_message,
              //   this.assitPeopleInfo
              // )
            }
            this.spinning = false
          })
        }
        // ------------
        // 如果是从草稿点击进来的，并且状态为退回拟稿状态时，接口 查询出暂存数据
        // console.log('huyizancuntext', this.initData)
        if (this.pageType === 'draft' && (this.processData.process_base_status === 'ReturnDraft' || this.processData.process_base_status === 'Draft')) {
          request({
            url: `process/getReturnDraft`,
            method: 'post',
            data: {
              process_base_work_flow_number: this.initData.init_value.process_base_work_flow_number
            }
          }).then((ret) => {
            // console.log('huyizancuntest', this.initData)
            if (ret) {
              this.initData.init_value.process_base_table_message = JSON.parse(ret.process_base_table_message)
            }

            // alert('取出暂存')
          })
        }
        // ------------
      })
    }

    this.$store.dispatch('GetNational').then(response => {
      this.minzuList = response
    })
  },
  methods: {
    ...mapActions(['InitProcess', 'GetTaskBusinessData']), // vuex中的获取初始表单数据方法

    xingmingOnchange(e) {
      // this.$refs.caseApplyForm.setYewushixiang(e)
      this.initData.init_value.process_base_table_message.need_help_person_name = e
      this.$forceUpdate()
      console.log('xingmingOnchange触发的', this.initData)
    },
    shifouqushenpiChange(e) {
      console.log('是否提交区审批', e)
      // this.shifouqushenpiVal = e
      this.$refs.leaderList.setShifouqushengpi(e)
    },
    dayin() {
      // window.print()
      const style = '@page {margin:0 10mm}  .ant-form-item label{margin-right: 12px!important}'// 打印时去掉眉页眉尾
      // 打印为什么要去掉眉页眉尾？因为眉页title时打印当前页面的title，相当于是获取html中title标签里面的内容，但是比如我打印的内容只是一个弹框里面的内容，是没有title的，这时候就会出现undefined，为了避免出现这种情况，就可以隐藏眉页眉尾
      // eslint-disable-next-line no-undef
      printJS({
        printable: 'print', // 标签元素id
        type: 'html',
        header: '',
        font_size: '',
        maxWidth: 4000,
        targetStyles: ['*'],
        style
      })
      // 各个配置项
      // printable:要打印的id。
      // type:可以是 html 、pdf、 json 等。
      // properties:是打印json时所需要的数据属性。
      // gridHeaderStyle和gridStyle都是打印json时可选的样式。
      // repeatTableHeader:在打印JSON数据时使用。设置为时false，数据表标题将仅在第一页显示。
      // scanStyles:设置为false时，库将不处理应用于正在打印的html的样式。使用css参数时很有用，此时自己设置的原来想要打印的样式就会失效，在打印预览时可以看到效果
      // targetStyles: [’*’],这样设置继承了页面要打印元素原有的css属性。
      // style:传入自定义样式的字符串，使用在要打印的html页面 也就是纸上的样子。
      // ignoreElements：传入要打印的div中的子元素id，使其不打印。非常好用
    },
    zancun() {
      this.spinning = true
      var baseData = this.$refs.caseBaseForm.getValue()
      var familyData = this.$refs.familyForm.getValue()
      var applyData = this.$refs.caseApplyForm.getValue()
      var examineData = this.$refs.examineForm.getValue()
      var reviewData = this.$refs.reviewForm.getValue()

      applyData.individual_case_apply_time = applyData.individual_case_apply_time
        ? moment(applyData.individual_case_apply_time._d).format('YYYY-MM-DD')
        : ''
      reviewData.review_time = reviewData.review_time
        ? moment(reviewData.review_time._d).format('YYYY-MM-DD')
        : ''
      examineData.examineForm_time = examineData.examineForm_time
        ? moment(examineData.examineForm_time._d).format('YYYY-MM-DD')
        : ''

      request({
        url: `process/saveReturnDraft`,
        method: 'post',
        data: {
          process_base_work_flow_number: this.initData.init_value.process_base_work_flow_number,
          process_base_table_message: JSON.stringify(
            Object.assign(this.initData.init_value.process_base_table_message, {
              ...baseData,
              ...familyData,
              ...applyData,
              ...reviewData,
              ...examineData
            })
          )
        }
      }).then((ret) => {
        this.$notification.success({
          message: '暂存成功'
        })
        this.spinning = false
        this.$router.push({ path: '/assit/personal' })
      })
    },
    // 判断是否展示,返回true就展示，false不展示
    checkDisplay(type) {
      if (
        this.assitPeopleInfoFlag ||
        this.pageType === 'approval' ||
        this.pageType === 'view' ||
        this.pageType === 'approvalFund'
      ) {
        // 当能查到用户信息时,无论什么页面类型，这些都不展示
        // switch (type) {
        // case 'increasePeople':
        //   return false // 新增家庭成员按钮不展示
        // case 'need_help_person_registered_address_detailed': // 详细地址
        //   return false
        // case 'need_help_person_current_address_detailed':
        //   return false
        // case 'detailAddress':
        //   return false // 项目选择提醒
        // }
      }
      if (this.pageType === 'launch') {
        // 页面为拟稿时，审批列表和审批控件都不展示
        switch (type) {
          case 'approvalList': // 审批列表
            return false
          case 'confirm':
            return false
          case 'zancun':
            return false
          case 'approval': // 审批控件
            return false
        }
      } else if (this.pageType === 'approval') {
        switch (type) {
          case 'confirm':
            return false
          case 'zancun':
            return false
          case 'increasePeople':
            return false
          case 'detailAddress':
            return false
          case 'save':
            return false // 审批时保存按钮不生成
          case 'reviewMembersNewTip':
            return false
        }
      } else if (this.pageType === 'draft') {
        switch (type) {
          case 'approvalList': // 审批列表
            return false
          case 'increasePeople':
            return true
          case 'confirm':
            return false
          case 'zancun':
            return false
          case 'approval':
            return false // 审批控件
        }
      } else if (this.pageType === 'relaunch') {
        switch (type) {
          case 'approval':
            return false // 审批控件
          case 'confirm':
            return false
          case 'save':
            return false // 审批时保存按钮不生成
          case 'zancun':
            return true // 退回拟稿状态，显示 暂存按钮
        }
      } else if (this.pageType === 'view') {
        switch (type) {
          case 'button':
            return false // 只读时按钮不生成
          case 'detailAddress':
            return false // 只读时按钮不生成
          case 'increasePeople':
            return false
          case 'confirm':
            return false
          case 'zancun':
            return false
          case 'approval':
            return false // 审批控件
          case 'reviewMembersNewTip':
            return false
        }
      } else if (this.pageType === 'approvalFund') {
        switch (type) {
          case 'save':
            return false // 只读时按钮不生成
          case 'detailAddress':
            return false // 只读时按钮不生成
          case 'increasePeople':
            return false
          case 'submit':
            return false // 只读时按钮不生成
          case 'zancun':
            return false
          case 'approval':
            return false // 审批控件
          case 'approvalLeader':
            return false // 审批领导
          case 'reviewMembersNewTip':
            return false
        }
      }
      return true
    },
    // 判断每个控件是否只读，不能更改，如果只读返回true，否则返回false
    checkDisabled(type) {
      if (this.pageType === 'approval' || this.pageType === 'view') {
        switch (
        type // 审批控件
        ) {
          default:
            return true
        }
      } else if (
        this.pageType === 'launch' ||
        this.pageType === 'relaunch' ||
        this.pageType === 'draft'
      ) {
        // if (this.assitPeopleInfoFlag) { // 当能查到用户信息时，这些都不可编辑
        //   switch (type) { // 审批控件
        //     case 'process_base_title':
        //       return false
        //     case 'individual_case_apply_time':
        //       return false
        //     case 'individual_case_instructions':
        //       return false
        //     case 'individual_case_support_funds':
        //       return false
        //     case 'review_isAgree':
        //       return false
        //     case 'review_time':
        //       return false
        //     case 'review_members':
        //       return false
        //     case 'review_content':
        //       return false
        //     case 'review_acceptanceOpinions':
        //       return false
        //     case 'review_remarks':
        //       return false
        //     default:
        //       return true
        //   }
        // } else { // 否则全部可编辑
        switch (
        type // 审批控件
        ) {
          default:
            return false
        }
        // }
      } else if (this.pageType === 'approvalFund') {
        if (type === 'grantForm') {
          return false
        } else {
          return true
        }
      }
    },
    // 下一步处理人弹出框
    nextStepHandler(params, data) {
      this.$confirm({
        title: data,
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          this.submit(params) // 提交
        },
        onCancel: () => {
          this.spinning = false
        }
      })
    },
    // 获取帮扶人员项目关联情况
    getProject(idCard) {
      // 项目关联
      // service.getTaskForProject({ need_help_person_number_id: idCard }).then(response => {
      //   this.projectRelate = response || []
      // })
      service.getTaskForUnProject({ need_help_person_number_id: idCard }).then((response) => {
        this.assitLog = response || []
        this.assitLog = this.assitLog.map(item => {
            if (item.process_base_work_number === this.processData.process_base_work_number) {
                this.$set(item, 'current', true)
            }
            return item
        })
      })
    },
    // 表单发起提交查找下一步处理人
    onSubmit() {
      if (this.pageType === 'launch' || this.pageType === 'relaunch' || this.pageType === 'draft') {
        const baseData = this.$refs.caseBaseForm.onSubmit()
        const familyData = this.$refs.familyForm.onSubmit()
        const applyData = this.$refs.caseApplyForm.onSubmit()
        const reviewData = this.$refs.reviewForm.onSubmit()
        const leaderList = this.$refs.leaderList.onSubmit()
        const examineData = this.$refs.examineForm.onSubmit()
        // 是否区审批和评议信息里保持一致
        leaderList.map((item, index) => {
            item.process_config_is_district = reviewData.process_config_is_district
            return item
        })
        console.log('测试-------------------------->', leaderList)
        // const noticeReader = this.$refs.noticeRead.getValue()
        if (this.assitPeopleInfoFlag) {
          // 如果后台有数据，就直接赋值为后台拿到的数据
          // baseData = this.assitPeopleInfo
          // familyData = this.assitPeopleInfo
        }
        // console.log(baseData, familyData, applyData, leaderList)
        if (leaderList && baseData && reviewData && examineData && applyData) {
          if (this.pageType === 'launch') {
            // 当页面类型为launch时，身份证号由路由带的参数提供
            baseData.need_help_person_number_id = JSON.parse(this.$route.query.idCard)
          }
          this.spinning = true
          service
            .nextStepHandler({
              baseData,
              // noticeReader,
              familyData,
              applyData,
              reviewData,
              examineData,
              leaderList,
              assitPeopleInfoFlag: this.assitPeopleInfoFlag,
              pageType: this.pageType
            })
            .then((response) => {
              this.nextStepHandler(
                {
                  baseData,
                  // noticeReader,
                  familyData,
                  applyData,
                  reviewData,
                  examineData,
                  leaderList,
                  assitPeopleInfoFlag: this.assitPeopleInfoFlag,
                  pageType: this.pageType
                },
                response
              )
            })
        }
      } else if (this.pageType === 'approval') {
        const approvalInfo = this.$refs.approval.onSubmit()
        if (approvalInfo) {
          this.spinning = true
          service.nextStepHandler({ approvalInfo, pageType: this.pageType }).then((response) => {
            this.nextStepHandler({ approvalInfo, pageType: this.pageType }, response)
          })
        }
      }
    },
    // 发起提交
    submit(params) {
      if (this.pageType === 'approval' || this.pageType === 'relaunch' || (this.pageType === 'draft' && this.processData.process_base_status === 'ReturnDraft')) {
        // 当是审批和退回拟稿的时候，提交走处理接口 ,  如果是从草稿点击进来的，并且状态为退回拟稿状态时 也走这个接口
        service.dispatchTask(params).then((response) => {
          this.$notification.success({
            message: '审批成功'
          })
          this.spinning = false
          this.$router.push({ path: '/assit/personal' })
          // this.goToHistory()
        })
      } else if (this.pageType === 'launch' || this.pageType === 'draft') {
        // 当是拟稿或者草稿发起的时候，走发起接口
        service.launchTask(params).then((response) => {
          this.$notification.success({
            message: '提交成功'
          })
          this.spinning = false
          this.$router.push({ path: '/assit/personal' })
          // this.goToHistory()
        })
      }
    },
    // 流程保存
    async saveDraft() {
      const baseData = this.$refs.caseBaseForm.getValue()
      const familyData = this.$refs.familyForm.getValue()
      const applyData = this.$refs.caseApplyForm.getValue()
      const examineData = this.$refs.examineForm.getValue()
      const reviewData = this.$refs.reviewForm.getValue()
      const leaderList = this.$refs.leaderList.getValue()
      // const noticeReader = this.$refs.noticeRead.getValue()
      // if (this.assitPeopleInfoFlag) {
        // 如果后台有数据个人信息就直接赋值
        // baseData = this.assitPeopleInfo
        // familyData = this.assitPeopleInfo
      // }
        // 是否区审批和评议信息里保持一致
      leaderList.map((item, index) => {
          item.process_config_is_district = reviewData.process_config_is_district
          return item
      })
      if (baseData) {
        this.spinning = true
        if (this.pageType === 'launch') {
          baseData.need_help_person_number_id = JSON.parse(this.$route.query.idCard)
            Object.assign(this.initData.init_value.process_base_table_message, {
                ...baseData,
                ...familyData,
                ...applyData,
                ...reviewData,
                ...examineData,
                ...leaderList
            })
          await service
              .saveProcessDraft({
                  baseData,
                  familyData,
                  applyData,
                  leaderList,
                  // noticeReader,
                  reviewData,
                  examineData,
                  assitPeopleInfoFlag: this.assitPeopleInfoFlag,
                  pageType: this.pageType
              })
              .then((response) => {
                  this.$notification.success({
                      message: '保存成功'
                  })
                  this.spinning = false
                  // this.$router.push({ path: '/assit/personal' })
                  // this.goToHistory()
              })
        } else if (this.pageType === 'draft') {
            await service
                .saveReturnDraft({
                    process_base_work_flow_number: this.initData.init_value.process_base_work_flow_number,
                    process_base_table_message: JSON.stringify(
                        Object.assign(this.initData.init_value.process_base_table_message, {
                            ...baseData,
                            ...familyData,
                            ...applyData,
                            ...reviewData,
                            ...examineData,
                            ...leaderList
                        })
                    )
                })
                .then((response) => {
                    this.$notification.success({
                        message: '保存成功'
                    })
                    this.spinning = false
                    // this.$router.push({ path: '/assit/personal' })
                    // this.goToHistory()
                })
        }
        this.spinning = false
      }
    },
    // async saveDraft() {
    //   let baseData = this.$refs.caseBaseForm.getValue()
    //   let familyData = this.$refs.familyForm.getValue()
    //   const applyData = this.$refs.caseApplyForm.getValue()
    //   const examineData = this.$refs.examineForm.getValue()
    //   const reviewData = this.$refs.reviewForm.getValue()
    //   const leaderList = this.$refs.leaderList.getValue()
    //   // const noticeReader = this.$refs.noticeRead.getValue()
    //   if (this.assitPeopleInfoFlag) {
    //     // 如果后台有数据个人信息就直接赋值
    //     baseData = this.assitPeopleInfo
    //     familyData = this.assitPeopleInfo
    //   }
    //   if (baseData) {
    //     this.spinning = true
    //     if (this.pageType === 'launch') {
    //       baseData.need_help_person_number_id = JSON.parse(this.$route.query.idCard)
    //     }
    //     await service
    //       .saveReturnDraft({
    //         process_base_work_flow_number: this.initData.init_value.process_base_work_flow_number,
    //         process_base_table_message: JSON.stringify(
    //           Object.assign(this.initData.init_value.process_base_table_message, {
    //             ...baseData,
    //             ...familyData,
    //             ...applyData,
    //             ...reviewData,
    //             ...examineData,
    //             ...leaderList
    //           })
    //         )
    //       })
    //       .then((response) => {
    //         this.$notification.success({
    //           message: '保存成功'
    //         })
    //         this.spinning = false
    //         // this.$router.push({ path: '/assit/personal' })
    //         // this.goToHistory()
    //       })
    //     this.spinning = false
    //   }
    // },
    // 资金确认
    onConfirm(type) {
      this.spinning = true
      const grantFormData = this.$refs.grantForm.onSubmit()
      if (grantFormData) {
        this.$confirm({
          title: '是否确认发放',
          okText: '确认',
          cancelText: '取消',
          onOk: () => {
            service.fundingApproval(type, grantFormData).then((response) => {
              this.$notification.success({
                message: '发放成功'
              })
              this.spinning = false
              this.goToHistory()
            })
          },
          onCancel: () => {
            this.spinning = false
          }
        })
      } else {
        this.spinning = false
      }
    },
    // 取消返回上一页
    goToHistory() {
      this.$router.go(-1) // 返回上一层
    }
  }
}
</script>

<style scoped lang="less">
@import "../../../style.less";
/deep/.ant-anchor-wrapper {
  background-color: #f0f2f5;
}
.dayin-view {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
</style>
